import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-cnae-modal',
  templateUrl: './cadastrar-cnae-modal.component.html',
  styleUrls: ['./cadastrar-cnae-modal.component.scss']
})
export class CadastrarCnaeModalComponent implements OnInit {
  novo = false;
  cnae: string = '';
  indexCnae: number;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<CadastrarCnaeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(this.data) {
      this.cnae = this.data.cnae;
      this.indexCnae = this.data.index;
    } else {
      this.novo = true;
    }
  }

  ngOnInit(): void {
  }

  fechar() {
    this.dialogRef.close();
  }

  salvar() {
    this.dialogRef.close({cnae: this.cnae, index: this.indexCnae});
  }
}
